<template>
  <div>
    <Tooltip
      v-if="hasTooltip"
      :class="$style.wordBreak"
      :hasIndicator="true"
      isDark
      orientation="left"
      :text="event.resource.hostname"
    >
      <Link
        v-if="deviceExists"
        :class="[$style.deviceLinkBorder, $style.textOverflow]"
        :text="event.resource.hostname"
        :to="deviceRoute"
      />
      <ParagraphBody
        v-else
        :class="[$style.cursorText, $style.textOverflow]"
        :hasMargin="false"
      >
        {{ event.resource.hostname }}
      </ParagraphBody>
    </Tooltip>
    <Link
      v-else-if="deviceExists"
      :class="$style.deviceLink"
      :text="event.resource.hostname"
      :to="deviceRoute"
    />
    <ParagraphBody
      v-else
      :hasMargin="false"
    >
      {{ event.resource.hostname }}
    </ParagraphBody>
  </div>
</template>

<script>
import {
  Link,
  ParagraphBody,
  Tooltip,
} from '@jumpcloud/ui-components';
import { isEmpty } from 'lodash';
import SystemApi from 'client/api/v2/SystemApi';

export default {
  name: 'HostnameLink',

  components: {
    Link,
    ParagraphBody,
    Tooltip,
  },

  props: {
    hasTooltip: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    device: {},
    event: {},
  }),

  computed: {
    deviceExists() {
      return !isEmpty(this.device);
    },

    deviceRoute() {
      return this.deviceExists ? `/devices/${this.event.resource.id}/details` : '';
    },
  },

  created() {
    this.event = this.item.event;
    this.fetchDeviceObject(this.event.resource.id);
  },

  methods: {
    async fetchDeviceObject(id) {
      try {
        this.device = await SystemApi.get(id);
      } catch (e) {
        this.device = {};
      }
    },
  },
};
</script>

<style module>

.deviceLink:hover {
  --jc-border-width: none;
}

.deviceLinkBorder:hover.deviceLinkBorder:hover {
  border-color: transparent;
}

.wordBreak span {
  cursor: text;
  word-break: break-all;
}

.cursorText {
  cursor: text;
}

.textOverflow {
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

</style>
